import React from 'react';
import './FabricationServices.css';

const FabricationServices = () => {
  const upcomingServices = [
    'Structural Mezzanine floors',
    'Furniture Items',
    'Decorative Elements',
    'Handrails',
    'Interior fit-out metal works',
    'Pergola & Canopies',
    'Support frames for cabinets and vanities',
    'Architectural Metal Works',
    'Signage works',
    'Steel Cat ladders',
    'Manhole covers',
    'Gratings',
    'OTS Platforms',
    'Safety Bollards & Barriers',
    'Gondola',
    'Stainless Steel Shower Drains',
    'Glass Fittings and Handles',
    'Metal Cutting & Bending',
    'Welding (MIG, TIG, Arc)',
    'Sheet Metal Fabrication'
  ];

  return (
    <section id="fabrication-services" className="fabrication-services">
      <div className="container">
        <div className="section-header">
          <h2><img src="/icons/tools.svg" alt="Tools" className="section-header-icon" /> Fabrication Services </h2>
          <p>We’re excited to announce that we’ve expanded our operations! Along with our premium powder coating services, we now offer complete metal fabrication solutions. Our bespoke steel work combines strength, precision, and aesthetics to elevate every project.</p>
        </div>
        
        <div className="upcoming-grid">
          {upcomingServices.map((service, index) => (
            <div key={index} className="upcoming-service">
              <img src="/icons/settings.svg" alt="Service" className="upcoming-service-icon" />
              <span>{service}</span>
            </div>
          ))}
        </div>

        {/* <div className="coming-soon-cta"> */}
          <div className="cta-content">
            <h3 style={{textAlign: 'center'}}>Let’s Bring Your Vision to Life !</h3>
            {/* <p>Our fabrication services will be launching soon. Contact us to be notified when these services become available.</p> */}
            {/* <div className="notify-button">
              <img src="/icons/bell.svg" alt="Notification" className="notify-icon" />
              <span>Coming Soon</span>
            </div> */}
          </div>
        {/* </div> */}
      </div>
    </section>
  );
};

export default FabricationServices;